import Box from "@material-ui/core/Box";
import InputAdornment from "@material-ui/core/InputAdornment";
import React, { useState } from "react";
import {
  FormattedMessage,
  WrappedComponentProps,
  injectIntl,
} from "react-intl";
import DeleteIcon from "@material-ui/icons/Delete";
import { IconButton, makeStyles } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";
import { CreateUserInput } from "../../types/graphql-global-types-onboarding";
import { isEmailValid } from "../../utils/Validator";
import CustomTextField from "../Ui/CustomTextField";

const styles = makeStyles((theme) => ({
  emailLoading: {
    display: "inline-flex",
    alignItems: "center",
    width: 242,
    "@media(max-width:780px)": {
      width: "100%",
      justifyContent: "center",
      marginRight: 0,
    },
  },
  input: {
    display: "inline-flex",
    width: 242,
    marginRight: 20,
    "@media(max-width:780px)": {
      width: "100%",
      justifyContent: "center",
      marginRight: 0,
    },
  },
  container: {
    display: "flex",
    "@media(max-width:1020px)": {
      display: "block",
    },
  },
  deleteIcon: {
    display: "flex",
    margin: 0,
    padding: 0,
    alignItems: "center",
    justifyContent: "center",
    "@media(max-width:780px)": {
      width: "100%",
      justifyContent: "center",
      marginRight: 0,
    },
  },
}));
interface ShareholderPercentProps {
  shareholder: CreateUserInput;
  isSubmitted?: boolean;
  isOwner?: boolean;
  total: number;
  index: number;
  handleChange: (
    index: number,
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleRemove?: (member: CreateUserInput) => void;
}

const ShareholderPercent = (
  props: WrappedComponentProps & ShareholderPercentProps,
) => {
  const { shareholder, total, handleChange, index, isOwner, handleRemove } =
    props;
  const classes = styles();
  const [isEmailNotValid, setIsEmailNotValid] = useState(false);
  const isSubmitted = props.isSubmitted ? props.isSubmitted : false;

  return (
    <Box marginBottom={2} width={"100%"} className={classes.container}>
      <Box
        className={classes.emailLoading}
        style={{
          marginRight:
            shareholder.email && !isEmailValid(shareholder.email) ? 8 : 20,
        }}
      >
        <CustomTextField
          name="email"
          label={<FormattedMessage id="form.email" />}
          placeholder="Email..."
          onChange={handleChange(index)}
          value={shareholder?.email || ""}
          isSubmitted={isSubmitted}
          disabled={true}
        />
        {shareholder.email && !isEmailValid(shareholder.email) ? (
          <ErrorIcon
            style={{ marginLeft: 8, marginRight: 8, color: "#FFCC00" }}
          />
        ) : isEmailNotValid ? (
          <ErrorIcon
            style={{ marginLeft: 8, marginRight: 8, color: "#FFCC00" }}
          />
        ) : (
          ""
        )}
      </Box>
      <Box className={classes.input}>
        <CustomTextField
          name="name"
          label={<FormattedMessage id="stepFive.form.name" />}
          placeholder="Nom..."
          onChange={handleChange(index)}
          value={shareholder?.name || ""}
          isSubmitted={isSubmitted}
        />
      </Box>
      <Box className={classes.input}>
        <CustomTextField
          name="firstname"
          label={<FormattedMessage id="stepFive.form.surname" />}
          placeholder="Prénom..."
          onChange={handleChange(index)}
          value={shareholder?.firstname || ""}
          isSubmitted={isSubmitted}
        />
      </Box>
      <Box className={classes.input}>
        <CustomTextField
          name="sharesPercentage"
          label={<FormattedMessage id="percent.label" />}
          placeholder="Prénom..."
          onChange={handleChange(index)}
          value={shareholder?.sharesPercentage?.toString() || "0"}
          isSubmitted={isSubmitted}
          type="number"
          inputProps={{
            min: 0,
            step: 0.5,
            max: !!total ? total : undefined,
          }}
          endAdornment={<InputAdornment position="end">%</InputAdornment>}
        />
      </Box>
      {!isOwner && (
        <IconButton
          aria-label="delete"
          className={classes.deleteIcon}
          onClick={(e) => {
            e.preventDefault();
            handleRemove && handleRemove(shareholder);
          }}
        >
          <DeleteIcon color="error" />
        </IconButton>
      )}
    </Box>
  );
};

export default injectIntl(ShareholderPercent);
